// extracted by mini-css-extract-plugin
module.exports =  {"trigger":"XIU1ZJWDTv_XyPuSCK2h"};